
import { Component, OnInit, DoCheck} from '@angular/core';
import {CollectorService} from '../collector/collector.service';
import {CoordService} from './coord.service';
import {StaticService} from '../consulta/static.service';
import {FchartalgoService} from '../fchart/fchartalgo.service';
import {tap} from 'rxjs/operators';
import {GeneralMessages} from '../shared/services';
import {SorterPipe} from '../sorter.pipe';


@Component({
  selector: 'app-captadores',
  templateUrl: './captadores.component.html',
  styleUrls: ['./captadores.component.scss'],
})
export class CaptadoresComponent implements OnInit, DoCheck {

  captadores;
  all_captadores = [];
  fscaptadores = [];
  param;

  offerloaded = null;
  fstimestamp = null;


  constructor(private coord: CoordService, private collector: CollectorService, private messaging: GeneralMessages,
                  private fchartalgo: FchartalgoService, private staticS: StaticService) {

  }

  ngOnInit() {
    this.fstimestamp = this.fchartalgo.getTimeStamp();
    this.param = this.staticS.getDefaultCaptadorParam();
    this.getAllCollectors().subscribe();
  }

  updateOnchange(){
    //this.param.selectedCaptador.accumulacion_optima = this.param.accumulation;
    this.fchartalgo.updateFSCaptadorManual(this.param.selectedCaptador,this.param.accumulation, this.param.number);
  }

  ngDoCheck() {
    if(this.offerloaded != this.staticS.getSelectedOffer()){
      this.offerloaded = this.staticS.getSelectedOffer();
      if (this.offerloaded != null){
        for (var i = 0; i < this.all_captadores.length; i++)
          if (this.all_captadores[i].id == this.offerloaded.collector){
            this.param.selectedCaptador = this.all_captadores[i];
            console.log(this.param.selectedCaptador);
            break;
          }
        this.param.number = this.offerloaded.num_collector;
        this.param.accumulation = this.offerloaded.total_accumulation;
        this.fscaptadores = this.fchartalgo.getFSCaptadores();
        this.fstimestamp = this.fchartalgo.getTimeStamp();
      }
      else {
        this.reset();
        this.fstimestamp = this.fchartalgo.getTimeStamp();
      }
    }
    if (!this.offerloaded && this.fscaptadores != this.fchartalgo.getFSCaptadores()  && this.captadores != null){
      this.fscaptadores = this.fchartalgo.getFSCaptadores();
      for (var i=0; i < this.fscaptadores.length; i++){
        this.captadores[i].unidades = this.fscaptadores[i].nb;
        this.captadores[i].accumulacion_optima = this.fscaptadores[i].accumulacion_optima;
        this.captadores[i].accumulacion = this.fscaptadores[i].accumulacion;
        this.captadores[i].stotal = this.captadores[i].unidades * this.captadores[i].superficie;
        if(this.fscaptadores[i].captador.Captador == this.param.selectedCaptador.Captador){
          this.param.selectedCaptador =  this.captadores[i];
          this.param.number = this.fscaptadores[i].nb;
          this.param.accumulation = this.fscaptadores[i].accumulacion_optima;
          this.fchartalgo.updateFSCaptador(this.param.selectedCaptador,this.param.accumulation, this.param.number);
        }
      }
    }
    if (!this.offerloaded && this.fstimestamp != this.fchartalgo.getTimeStamp()){
      if(this.captadores && this.fscaptadores && this.fscaptadores.length >0 && !this.offerloaded) {

        for (var i=0; i < this.captadores.length; i++){
          if(this.captadores[i].Captador == this.param.selectedCaptador.Captador){
            this.param.selectedCaptador =  this.captadores[i];
            this.param.number = this.fscaptadores[i].nb;
            break;
          }
        }

        if(this.param.selectedCaptador.accumulacion != this.param.selectedCaptador.accumulacion_optima) {
              //console.log(this.param.selectedCaptador)
              this.messaging.warning('Normativa de acumulación', 'Una acumulación de ' + this.param.selectedCaptador.accumulacion +
                    ' litros no permite respetar las normals de A.C.S.\n' + 'El volumen optimo más cercano es ' +
                    this.param.selectedCaptador.accumulacion_optima + ' Litros.');

              this.param.accumulation = this.param.selectedCaptador.accumulacion_optima;
              this.fchartalgo.updateFSCaptador(this.param.selectedCaptador,this.param.accumulation, this.param.number);
            }
      }
      this.fstimestamp = this.fchartalgo.getTimeStamp();
    }

  }

  update_number(){
    for (var i=0; i < this.fscaptadores.length; i++){
      if(this.fscaptadores[i].captador.Captador == this.param.selectedCaptador.Captador)
        this.param.number = this.fscaptadores[i].nb;
    }
    if (this.param.selectedCaptador && !this.offerloaded){
      this.fchartalgo.updateFSCaptador(this.param.selectedCaptador,this.param.accumulation, this.param.number);
    }
    var name = this.param.selectedCaptador.Captador;
    if (name.indexOf('2,6') >= 0 && name.indexOf('DB') >= 0 && this.param.accumulation < 200 && this.param.number == 1)
      this.param.accumulation = 200;
    else if (name.indexOf('2,6') >= 0 && name.indexOf('DB') >= 0 && this.param.accumulation < 300 && this.param.number == 2)
      this.param.accumulation = 300;
    else
      this.param.accumulation = this.param.selectedCaptador.accumulacion_optima;
  }

  selectCaptador() {
    var name = this.param.selectedCaptador.Captador;
    if (name.indexOf('2,6') >= 0 && name.indexOf('DB') >= 0 && this.param.accumulation < 200 && this.param.number == 1)
      this.param.accumulation = 200;
    else if (name.indexOf('2,6') >= 0 && name.indexOf('DB') >= 0 && this.param.accumulation < 300 && this.param.number == 2)
      this.param.accumulation = 300;
    else
      this.param.accumulation = this.param.selectedCaptador.accumulacion_optima;
    this.fchartalgo.setSelectedCaptador(this.param.selectedCaptador, this.param.accumulation);
    this.update_number();
  }

  reset(){
    this.param.selectedCaptador = this.captadores[0];
    this.param.selectedCaptador.accumulacion_optima = 150;
    this.param.number =  1;
    this.param.accumulation = 150;
    this.fchartalgo.setSelectedCaptador(this.captadores[0], 150);
  }



  getAllCollectors() {
    return this.collector.get().pipe(
      tap(data => {
        this.captadores = data;
        var series = [];
        for (var i=0; i< this.captadores.length; i++){
            var capta = this.captadores[i];
            var ele = {
              Captador:capta.name,
              a0:capta.a0,
              a1:capta.a1,
              a2:capta.a2,
              superficie:capta.surface,
              unidades:1,
              stotal:capta.surface,
              onsale:capta.onsale,
              factor_intercambio:capta.factor_intercambio,
              id:capta.id
            };
            series.push(ele);
        }
        this.all_captadores = series;
        var filtered_series = [];
        for (var i = 0; i < series.length; i++)
          if (series[i].onsale)
            filtered_series.push(series[i]);
        this.captadores = new SorterPipe().transform(filtered_series, '');
        this.fchartalgo.setCaptadores(this.captadores);
        this.reset();
        this.fstimestamp = this.fchartalgo.getTimeStamp();
        console.log(this.all_captadores);
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/captadores/captadores.component.ts